import React, { useEffect, useState } from 'react';
import IconTip from '@/components/icon-tip';
import PageAdapter from '@/components/page-adapter';
import Card from '@/components/card';
import apis from '../../../../apis';
import { message, Tooltip } from '@drip/drip-design';
import utils from '@/common/utils';

export default function (props) {
  const [data, setData] = useState();

  useEffect(() => {
    if (!props.filter) return;
    apis.queryParticipantChannelInfo({ ...props.filter, channelStatus: '2' }).then((res) => {
      const { ret, data, msg } = res;
      if (ret === '0') {
        setData(data);
      } else {
        message.error(msg);
        setData();
      }
    });
  }, [props.filter]);

  return (
    <div>
      <div className="channel-tab-card-bg">
        <div className="channel-tab-card-title">
          正在参与中的频道
          <IconTip title="已参与的正在进行中的活动列表。" />
        </div>
        <PageAdapter blockWidth={300} blockHeight={130} space={[16, 0]}>
          {data?.participating.length > 0 &&
            data.participating.map((item) => {
              return (
                <Card
                  container={{
                    padding: { vertical: true, horizontal: true },
                    paddingSize: 'min',
                    margin: false,
                  }}
                  style={{ background: '#FAFAFC', width: '288px' }}
                  key={item.channelId}
                >
                  <div className="ongoing-channel-card">
                    <div className="ongoing-channel-card-title">{item.channelName}</div>
                    <Tooltip title={item.remark}>
                      <div className="ongoing-channel-card-subtitle">{item.remark}</div>
                    </Tooltip>
                    <a
                      onClick={() => {
                        props.setSecKill({
                          realTime: 0,
                        });
                      }}
                    >
                      查看
                    </a>
                  </div>
                </Card>
              );
            })}
        </PageAdapter>
      </div>
    </div>
  );
}
